import offerImage from './img/sweepstakes/switch/320x180.jpg'
import SweepstakesBasePage from './SweepstakesBasePage'

const Page: React.FC = () => {
  return <SweepstakesBasePage optionsId={''} funnelName="switch" offerImage={offerImage} offerTitle="Nintendo Switch" />
}

export default Page
